module.exports = __webpack_public_path__ + "static/images/maestro.2bmdLdW.svg";